<div
  class="flex flex-col gap-10 p-5 bg-white divide-y rounded-10 divide-grey-5"
>
  <!-- <app-calender *ngIf="!isfloating"></app-calender> -->
  <app-pre-render-calendar />

  <!-- START :: MY LEAGUE -->

  <div class="flex flex-col gap-4 py-4">
    <!-- <app-skeleton-banner [bannerSize]="firstSizeBanner" /> -->
    <div class="flex items-center justify-between gap-2">
      <div class="cursor-pointer font-roboto-500 text-18">
        {{ "Mis Ligas" }}
      </div>
      <div class="ml-auto font-roboto-400 text-14 text-grey-2">
        {{ "Añadir más" }}
      </div>
      <img
        alt="plus"
        class="cursor-pointer"
        [src]="urlIcon + 'add-rounded.svg'"
      />
    </div>

    <app-no-result message="Error al cargar ligas" />
  </div>

  <div class="flex flex-col gap-4 py-4">
    <div class="flex items-center justify-between gap-2">
      <div class="cursor-pointer font-roboto-500 text-18">
        {{ "Mis Equipos" }}
      </div>
      <div class="ml-auto font-roboto-400 text-14 text-grey-2">
        {{ "Añadir más" }}
      </div>
      <img
        alt="plus"
        class="cursor-pointer"
        [src]="urlIcon + 'add-rounded.svg'"
      />
    </div>

    <app-no-result message="Error al cargar equipos" />
  </div>

  <div class="flex flex-col gap-4 py-4">
    <div class="flex items-center justify-between gap-2">
      <div class="cursor-pointer font-roboto-500 text-18">
        {{ "Países" }}
      </div>
    </div>

    <app-no-result message="Error al cargar países" />
  </div>

  <!-- END :: MY LEAGUE -->

  <!-- START :: MY TEAMS -->

  <!-- <app-team-favorite-list
    [isLoading]="teamsFavoritesStatus().isLoading"
    [favTeams]="myTeamsFavorites()"
    (onChangeModalTeam)="openModalFavoriteTeam()"
    (onChangeTypeSport)="changeTypeSport($event)"
  /> -->
  <!-- END :: MY TEAMS -->
</div>

<div class="flex justify-center mt-5" *ngIf="!isfloating"></div>
